import { Loader2 } from "lucide-react";

export function RouteLoading({
  label = "Loading…",
  fullScreen = false,
}: { label?: string; fullScreen?: boolean }) {
  if (fullScreen) {
    return (
      <div className="h-screen grid place-items-center text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          {label}
        </div>
      </div>
    );
  }
  return <div className="p-8 text-sm text-muted-foreground">{label}</div>;
}

export function RouteError({
  message,
  fullScreen = false,
}: { message: string; fullScreen?: boolean }) {
  if (fullScreen) {
    return (
      <div className="h-screen grid place-items-center p-8 text-center text-sm text-destructive">
        {message}
      </div>
    );
  }
  return <div className="p-8 text-sm text-destructive">{message}</div>;
}

